import { defineStore } from 'pinia'
import type { GameItem } from '~/composables/lobby-games/interface'

export type GameSlotJackpotResponseData = Record<string, number>

export interface JackpotXocdia {
  gameId: string
  gameName: string
  value: number
}

export interface TopWinner {
  username: string,
  stake: number,
  winlost: number,
  recent_game: GameItem,
  amount: number
}

export interface BigJackpot {
  configValue: number
  currentValue: number
  id: string
  name: string
  on: boolean
}

interface Jackpot {
  topWinners: TopWinner[]
  bigJackpotData: BigJackpot[],
  data: GameSlotJackpotResponseData,
  xocdia: JackpotXocdia
}

const STORE_NAME = 'jackpot'

export const useJackpotStore = defineStore(STORE_NAME, {
  state: (): Jackpot => ({
    topWinners: [],
    bigJackpotData: [],
    data: {},
    xocdia: {
      gameId: '',
      gameName: '',
      value: 0
    }
  }),
  persist: false,
  actions: {
    setTopWinners(topWinners: TopWinner[]): void {
      this.topWinners = topWinners
    },
    getTopWinners(): TopWinner[] {
      return this.topWinners
    },
    setBigJackpot(bigJackpots: BigJackpot[]): void {
      this.bigJackpotData = bigJackpots
    },
    getBigJackpot(): BigJackpot[] {
      return this.bigJackpotData
    },
    setJackpot(data: GameSlotJackpotResponseData): void {
      this.data = data
    },
    getJackpot(): GameSlotJackpotResponseData {
      return this.data
    },
    setXocDiaJackpot(jackpot: JackpotXocdia): void {
      this.xocdia = jackpot
    },
    getXocDiaJackpot(): JackpotXocdia {
      return this.xocdia
    }
  }
})
